import React, { useEffect, useState } from "react";
import { getCountries } from "../actions";

const useGetAvailableCountries = () => {
  const [availableCountries, setAvailableCountries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAvailableCountries = async () => {
      setLoading(true);
      const countryData = await getCountries();
      setAvailableCountries(countryData);
      setLoading(false);
    };
    fetchAvailableCountries();
  }, []);

  return { availableCountries, loading };
};

export default useGetAvailableCountries;
